<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12 text--base">
        <div class="chart__viz-emissions">
          <div class="container-fluid chart__white" v-if="vizScopes.content">
            <div class="row">
              <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 offset-md-2 offset-sm-1">
                <div class="mb-30">
                  <h3 class="text-body--large mb-15 font-weight-bold">
                    {{ vizScopes.content.header }}
                  </h3>
                  <p class="text-body mb-15">
                    {{ vizScopes.content.subtitle }}
                  </p>
                  <p class="text-body legend">
                    <span class="dot" style="background-color: #bfc9ff" />
                    <span class="dot" style="background-color: #a1e6bd" />
                    {{ vizScopes.content.instruction }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="chart__white">
            <VizScope3 />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import VizScope3 from '@/components/content/VizScope3.vue';

export default {
  name: 'App1Scope3',
  components: {
    VizScope3,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    vizScopes() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'viz-scopes') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  }
};
</script>

<style scoped lang="scss">
.chart__viz-emissions {
  padding: 60px 0;
  @media #{map-get($media-breakpoints, 'mobile')} {
    padding: 30px 0;
  }
}

.mb-15 {
    margin-bottom: 15px;
}
.mb-30 {
    margin-bottom: 30px;
}

.legend {
  display: grid;
  grid-template-columns: 20px 20px auto;
  align-items: baseline;
  column-gap: 5px;

  .dot {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
    vertical-align: start;
  }
}

h3.text-body--large {
  font-size: 20px;
  line-height: 1.35;
  font-weight: 700;
}
</style>